import React, { Component } from 'react'
import styles from "./ExtendPullBar.module.css"

import EXPAND_SRC from "../../static/icons8-expand-arrow-64.png"

const EXPAND_BAR_HEIGHT = 16
export default class ExtendPullBar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            trigger: false,
            originalY: null,
            top: 0,
        }

        this.node = null
    }
    //hadnler
    downHandler = (e) => { this.setState(state => { return { trigger: !state.trigger, } }) }
    upHandler = (e) => { this.setState(state => { return { trigger: false } }) }
    moveHandler = (e, target) => {
        if (target && this.state.trigger) {
            var setYPostion = e.pageY - this.state.originalY - (EXPAND_BAR_HEIGHT / 2)
            this.setState(state => {
                return {
                    top: (setYPostion >= 0) ? setYPostion : 0
                }
            }, () => {
                if (this.props.extendBarHeightCallback)
                    this.props.extendBarHeightCallback(setYPostion)
            })
        }
    }

    //sub-component
    showHeightInfo = () => {
        const style = { visibility: (this.state.trigger) ? "" : "hidden" }
        return (
            <div className={styles.textInfoStyle} style={style}>
                {parseInt(this.state.top)}
            </div>
        )
    }
    // life cycle
    componentDidMount() {
        document.addEventListener("mousemove", (e) => {
            this.moveHandler(e, this.node)
        })
        this.setState(state => {
            return {
                originalY: this.node.getBoundingClientRect().y,
                top: `${this.props.defaultHeight}`
            }
        })
    }

    render() {
        const style = {
            top: `${this.state.top}px`,
            height: (this.state.trigger) ? `${EXPAND_BAR_HEIGHT}px` : "0px",
            backgroundColor: (this.state.trigger) ? "rgb(236, 128, 40)" : "lightgrey",
            cursor: "row-resize"
        }
        const imgStyle = {
            width: (this.state.trigger) ? "40px" : "24px",
            height: (this.state.trigger) ? "40px" : "24px",
        }
        return (
            <div className={styles.container} style={style}
                ref={(ref) => this.node = ref}
                onMouseDown={this.downHandler}>
                <img className={styles.imgStyle} style={imgStyle} src={EXPAND_SRC} />
                {this.showHeightInfo()}
            </div >
        )
    }
}
